import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  SaveBtn,
  addForecastSpecificationStartYearGreaterThanMRY,
  addForecastSpecificationStartYearLessThanFEY,
  endYearGreaterThanFEYear,
  endYearLessThanStartYear,
  paramNameValidationMsg,
  paramNameUniqueMsg,
  CAGRPercentageError,
  only2DecimalsAllowed,
  only4DecimalsAllowed,
  maxlimitExceeded,
  onlyNumberWithDecimalMsg,
  setParameters,
  addGMPparameterType,
  addGMPParameterName,
  addGMPForceCost,
  addGMPVariableType,
  addGMPSourceYear,
  addGMPSource,
  addGMPDependency,
  addGMPStartYearValue,
  addGMPCurrencyUnit,
  addGMPUnit,
  addGMPStartYear,
  addGMPEndyear,
  addGMPCAGR,
  addGMPDataTypeOptions,
  addGMPForceCostOptions,
  addGMPVariableTypeOptions,
  addGMPDependencyOptions,
  addGMPDependencyOptionsNew,
  setparametersTooltip,
  addGMPDatatypeTooltip,
  addGMPParamterTooltip,
  forceAsCostTooltip,
  vartypeTooltip,
  sourceYearTooltip,
  sourceTooltip,
  dependency,
  selectGMPUnit,
  addGMPstartYearTooltip,
  currencyUnitTooltip,
  addGMPUnitTooltip,
  addGMPEndYearTooltip,
  CAGRTooltip,
  addGMPStartValueTooltip,
  createNewGMPUnit,
  SearchNewGMPUnit,
  DataSelection,
  decimalNumberRegExp,
  decimalFourNumberRegExp,
  addGMPVariableTypes,
  IndependentHierachrchy,
  FinancialParameterAddedSuccessfully,
  financialParameterNameRegExp,
  maxLength100,
  financialParaNameLength,
  sourceLength,
  dataUnitLength,
  financialParaNameRequired,
  dataUnitRequired,
  maxLength200,
  adDataUnitError,
  commonError,
  wafErrorMessage,
  financialParamDataUnitRegExp,
  HIERARCHY_FILTER_KEYS
} from "../../../util/constants";
import { SaveIcon, RefreshIcon, AreaSeacrhIcon } from "../../../icons";
import { Select } from "../../CommonUIComponents/Select/Select.jsx";
import { Button } from "../..";
import { Input } from "../../CommonUIComponents/Input/Input.jsx";
import { useDispatch, useSelector } from "react-redux";
import {
  saveGMPData,
  getGMPData,
  getParameterMatch,
  getUniqueParameterFlag
} from "../../../store/services/gmp.service";
import {
  setGMPDetails,
  setVariableTypeValue,
} from "../../../store/slices/gmpSlice";
import { LoadingIndicatorEmbed } from "../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed.jsx";
import { Tooltip } from "../../CommonUIComponents/Tooltip/Tooltip";
import MultiSelectCreatableOption from "../../CommonUIComponents/MultiSelectCreatableOption";
import { EmissionIcon } from "../../../icons";
import { ToastMessage } from "../../CommonUIComponents/ToastMessage/ToastMessage";
import { GMPHierarchy } from "../GMPHierarchy/GMPHierarchy";
import {
  setselectedUIAllFilters,
  setGMPHierarchy,
} from "../../../store/slices/gmpSlice";
import { setWafErrorFlag } from "../../../store/slices/projectSlice.js";

export function GMPParameters() {
  const dispatch = useDispatch();
  const engagement = useSelector((state) => state.engagement.engagement);
  const user = useSelector((state) => state.user.user);
  const gmp = useSelector((state) => state.gmp.gmp);
  const selectedUIAllFilters = useSelector(
      (state) => state.gmp.selectedUIAllFilters
    );
  const hierarchialData = useSelector((state) => state.project.hierarchialData);
  const wafErrorFlag = useSelector((state) => state.project.wafErrorFlag);
  const [gmpdataType, setGMPdataType] = useState("");
  const [gmpParameterName, setParameterName] = useState("");
  const [gmpForceCost, setForceCost] = useState("");
  const [gmpVariableType, setVariableType] = useState("");
  const [gmpSourceYear, setSourceYear] = useState("");
  const [gmpSource, setSource] = useState("");
  const [gmpDependency, setDependency] = useState("");
  const [gmpStartYearValue, setStartYearValue] = useState("");
  const [gmpCurrencyUnit, setCurrencyUnit] = useState("$");
  const [gmpUnit, setUnit] = useState("");
  const [gmpStartYear, setStartYear] = useState("");
  const [gmpEndYear, setEndyear] = useState("");
  const [gmpCAGR, setCAGR] = useState("");
  const [showstartYearError, setShowStartYearError] = useState(false);
  const [showendYearError, setShowEndYearError] = useState(false);
  const simulateLoader = false;
  const [saveLoader, setSaveLoader] = useState(false);
  const [valueError, setValueError] = useState(false);
  const [valueSYErrorMessage, setSYValueErrorMessage] = useState("");
  const [valueSYError, setSYValueError] = useState(false);
  const [CAGRErrorMessage, setCAGRErrorMessage] = useState("");
  const [CAGRError, setCAGRError] = useState(false);
  const [startYearErrorMessage, setStartYearErrorMessage] = useState("");
  const [endYearErrorMessage, setEndYearErrorMessage] = useState("");
  const [paramNameErrorMessage, setParamNameErrorMessage] = useState("");
  const [paramNameError, setParamNameError] = useState(false);
  const [sourceErrorMessage, setSourceErrorMessage] = useState("");
  // Emmission Data Unit Error Message
  const [dataUnitErrorMessage, setDataUnitErrorMessage] = useState("");

  // Activity Data Unit Error Message
  const [adUnitErrorMessage, setADUnitErrorMessage] = useState("");

  const [isSaveBtn, setSaveBtn] = useState(true);
  const [isResetBtn, setResetBtn] = useState(true);
  const [toastMessage, setToastMessage] = useState(false);
  const [hideFieldForDisRate, setHideFieldForDisRate] = useState(false);
  const [hideFieldForIndependent, setHideFieldForIndependent] = useState(false);
  const [isHierarchyModalOpen, openHierarchyModal] = useState(false);
  const [gmpADUnit, setGMPADUnit] = useState("");
  const lastCheckedParamName = useRef("");
  const [wafErrorMessageState, setWafErrorMessageState] = useState("");
  const ACTIVITY_DATA_OPTION = addGMPDependencyOptions[0];
  const EMISSIONS_OPTION = addGMPDependencyOptions[1];
  const NOT_APPLICABLE_OPTION = addGMPDependencyOptions[2];
  const DISCOUNT_RATE_OPTION = addGMPDataTypeOptions[2];
  
  // Close hierarcht popup
  const closeHierarchyModal = () => {
    openHierarchyModal(false);
  };
  // Function to show and hide toast message
  useEffect(() => {
    if (toastMessage) {
      setInterval(() => {
        setToastMessage(false);
      }, 5000);
    }
  }, [toastMessage]);

  useEffect(() => {
    if (wafErrorFlag) {
      setWafErrorMessageState(wafErrorMessage);
    }
  }, [wafErrorFlag]);

  //Onclick function on GMP field
  const handleOnChange = (value, fieldName) => {
    dispatch(setWafErrorFlag(false));
    if (fieldName === "gmpdataType") {
      setGMPdataType(value);
      setStartYearValue("");
      if (value === DISCOUNT_RATE_OPTION) {
        setForceCost("No");
        setVariableType(addGMPVariableTypes.dependent);
        setDependency(EMISSIONS_OPTION);
        setUnit("%");
        setHideFieldForDisRate(true);
        setHideFieldForIndependent(false);
      } else {
        setForceCost("");
        setVariableType("");
        setDependency("");
        setUnit("");
        setHideFieldForDisRate(false);
        setHideFieldForIndependent(true);
      }
    } else if (fieldName === "gmpParameterName") {
      dispatch(setWafErrorFlag(false));
      let error = "";
      if (value?.length >= maxLength100) {
        error = financialParaNameLength;   
        setParamNameErrorMessage(error); 
        setParamNameError(true);
        return;
      } else {
        setParamNameErrorMessage("");
        setParamNameError(false);
      }
      setParameterName(value);
      let flag = false;
      if (
        financialParameterNameRegExp.test(value) &&
        value !== "-"
      ) {
        if (!value) {
          error = financialParaNameRequired;
          flag = true;
          lastCheckedParamName.current = "";
        }
        setParamNameErrorMessage(error);
        setParamNameError(flag);
      } else {
        error = commonError;
        flag = true;
        setParamNameError(flag);
        setParamNameErrorMessage(error);
      }
    } else if (fieldName === "gmpForceCost") {
      setForceCost(value);
    } else if (fieldName === "gmpVariableType") {
      if (value === addGMPVariableTypes.independent) {
        setHideFieldForIndependent(true);
      } else {
        setHideFieldForIndependent(false);
      }
      setDependency("");
      setVariableType(value);
      dispatch(setVariableTypeValue({ variableType: value }));
    } else if (fieldName === "gmpSourceYear") {
      setSourceYear(value);
    } else if (fieldName === "gmpSource") {
      let error = "";
      if (value?.length >= maxLength200) {
        error = sourceLength;   
        setSourceErrorMessage(error); 
        return;
      } else {
        setSourceErrorMessage("");
      }
      setSource(value);
      if (
        financialParameterNameRegExp.test(value) &&
        value !== "-"
      ) {
        setSourceErrorMessage('');
      } else {
        error = commonError;
        setSourceErrorMessage(error);
      }
    } else if (fieldName === "gmpDependency") {
      setDependency(value);
      if (value === EMISSIONS_OPTION) {
        setUnit("kgCO2e");
      } else {
        setGMPADUnit("");
        setUnit("");
      }
      if (value === NOT_APPLICABLE_OPTION && gmpStartYearValue) {
        checkStartYearValueValidation(gmpStartYearValue);
      } else {
        checkStartYearValueValidationNew(gmpStartYearValue);
        setValueError(false);
      }
    }
    else if (
      fieldName === "gmpStartYearValue" &&
      gmpDependency !== NOT_APPLICABLE_OPTION
    ) {
      checkStartYearValueValidationNew(value);
      setStartYearValue(value);
      setValueError(false);
    } else if (fieldName === "gmpCurrencyUnit") {
      setCurrencyUnit(value);
    } else if (fieldName === "gmpUnit") {
      const val = value == null ? "" : String(value);
      setUnit(val);
      // 1) Required
      if (!val.trim()) {
        setDataUnitErrorMessage(dataUnitRequired);
        if (
          lastCheckedParamName &&
          lastCheckedParamName.current !== undefined
        ) {
          lastCheckedParamName.current = "";
        }
        return;
      }
      // 2) Length
      if (val.length >= maxLength200) {
        setDataUnitErrorMessage(dataUnitLength);
        return;
      }
      // 3) Disallowed literal
      if (val === "-") {
        setDataUnitErrorMessage(adDataUnitError);
        return;
      }
      // 4) Pattern
      if (!financialParamDataUnitRegExp.test(val)) {
        setDataUnitErrorMessage(adDataUnitError);
        return;
      }
      // 5) Valid
      setDataUnitErrorMessage("");
    } else if (fieldName === "gmpADUnitField") {
      let error = "";
      const label = value?.[value.length - 1]?.label || "";
      
      // Length validation
      if (label.length >= maxLength200) {
        error = dataUnitLength;
        // Clear the field to prevent invalid value
        setGMPADUnit("");
        // Set error message after clearing to ensure it persists
        setADUnitErrorMessage(error); 
        return;
      }
      
      // Pattern validation
      if (
        financialParamDataUnitRegExp.test(label) &&
        label !== "-"
      ) {
        // Valid: Set value and clear errors
        setGMPADUnit(label);
        setADUnitErrorMessage("");
      } else {
        // Invalid pattern: Clear field and show error
        setGMPADUnit("");
        setADUnitErrorMessage(adDataUnitError);
      }
    } else if (fieldName === "gmpStartYear") {
      checkStartYearValidation(value);
      setStartYear(value);
    } else if (fieldName === "gmpEndYear") {
      checkEndYearValidation(value);
      setEndyear(value);
    } else if (fieldName === "gmpCAGR") {
      checkCAGRvalidation(value);
      setCAGR(value);
    }
  };

  //Start year value validation for 0 to 100 in %
  const checkStartYearValueValidation = (value) => {
    setValueError(false);
    if (value && value < 0) {
      setValueError(true);
    } else if (value && !decimalNumberRegExp.test(value)) {
      setValueError(true);
    } else if (value && parseFloat(value) > 100) {
      setValueError(true);
    } else {
      setValueError(false);
    }
  };

  //Start year value validation for upper limit 99999999999 and lower limit - 99999999999
  const checkStartYearValueValidationNew = (value) => {
    setSYValueErrorMessage("");
    setSYValueError(false);
    if ((value && value > 99999999999.99) || value < -99999999999.99) {
      setSYValueErrorMessage(maxlimitExceeded);
      setSYValueError(true);
    } else if (value === "-") {
      setSYValueErrorMessage(onlyNumberWithDecimalMsg);
      setSYValueError(true);
    }
    else if (value && !decimalFourNumberRegExp.test(value) && value !== "-") {
      setSYValueErrorMessage(only4DecimalsAllowed);
      setSYValueError(true);
    } else {
      setSYValueErrorMessage("");
      setSYValueError(false);
    }
  };

  //CAGR value validation for -100 % to 9999.99 in %
  const checkCAGRvalidation = (value) => {
    if ((value && value < -100) || value > 9999.99) {
      setCAGRErrorMessage(CAGRPercentageError);
      setCAGRError(true);
    } else if (value && !decimalNumberRegExp.test(value)) {
      setCAGRError(true);
      setCAGRErrorMessage(only2DecimalsAllowed);
    } else {
      setCAGRError(false);
      setCAGRErrorMessage("");
    }
  };

  // Disable Save Button logic
  useEffect(() => {
    if (
      gmpdataType &&
      gmpParameterName &&
      gmpVariableType &&
      gmpStartYearValue &&
      gmpCurrencyUnit &&
      gmpStartYear &&
      gmpEndYear &&
      ((gmpVariableType === addGMPVariableTypes.dependent &&
        gmpDependency &&
        gmpForceCost &&
        ((gmpDependency === addGMPDependencyOptions[0] && gmpADUnit) || (gmpDependency === addGMPDependencyOptions[1] && gmpUnit)) &&
        gmp?.gmpHierarchyDataSet &&
        Object.keys(gmp?.gmpHierarchyDataSet).length > 0) ||
        gmpVariableType === addGMPVariableTypes.independent) &&
      !valueError &&
      !valueSYError &&
      !CAGRError &&
      !showstartYearError &&
      !showendYearError &&
      !paramNameError &&
      !adUnitErrorMessage &&
      !dataUnitErrorMessage &&
      !sourceErrorMessage
    ) {
      setSaveBtn(false);
    }
    else {
      setSaveBtn(true);
    }
  });

  // Disable Reset Button logic
  useEffect(() => {
    if (
      gmpdataType &&
      gmpParameterName &&
      gmpForceCost &&
      gmpVariableType &&
      gmpDependency &&
      gmpStartYearValue &&
      gmpCurrencyUnit &&
      gmpUnit &&
      gmpStartYear &&
      gmpEndYear
    ) {
      setResetBtn(false);
    }
    else if (
      gmpdataType &&
      gmpParameterName &&
      ((gmpVariableType === addGMPVariableTypes.dependent && gmpForceCost && gmpDependency) ||
        gmpVariableType === addGMPVariableTypes.independent) &&
      gmpStartYearValue &&
      gmpStartYear &&
      gmpEndYear
      // gmpCAGR
    ) {
      setResetBtn(false);
    } else {
      setResetBtn(true);
    }
  });

  // useEffect(() => {
  //   async function GetProjectDistinctADUnitsFn() {
  //     const request = { engagementCode: engagement.engagementCode };
  //     const data = await getDistinctADUnit({ request });
  //     setAvilableADUnits(data);
  //   }
  //   if (engagement?.engagementCode) {
  //     GetProjectDistinctADUnitsFn();
  //   }
  // }, [engagement?.engagementCode, dispatch]);

  useEffect(() => {
    dispatch(setVariableTypeValue({ variableType: gmpVariableType }));
  }, [gmpVariableType]);

  // Check Duplicate Param Name
  const checkDuplicateParamName = async () => {
    if (
      gmpdataType !== "" &&
      gmpVariableType !== ""
    ) {
      const payload = {
        gmP_data_type: gmpdataType,
        variable_type: gmpVariableType,
        dependency: gmpDependency ? gmpDependency : addGMPDependencyOptions[1],
        parameter_name: gmpParameterName,
        force_as_cost: gmpForceCost ? gmpForceCost : "No",
        engagementCode: engagement.engagementCode,
      };
      const data = await getParameterMatch({ payload });
      return data;
    }
  };

  // Check Year validation
  const checkStartYearValidation = (value) => {
    const mostRecentYear = engagement.mostRecentYear;
    if (value && parseFloat(value) <= mostRecentYear) {
      setStartYearErrorMessage(addForecastSpecificationStartYearGreaterThanMRY);
      setShowStartYearError(true);
    } else if (value && parseFloat(value) > engagement?.foreCastEndYear) {
      setStartYearErrorMessage(addForecastSpecificationStartYearLessThanFEY);
      setShowStartYearError(true);
    } else {
      setStartYearErrorMessage("");
      setShowStartYearError(false);
    }
  };

  const checkEndYearValidation = (value) => {
    const forecastEndYear = engagement.foreCastEndYear;
    if (value && parseFloat(value) > forecastEndYear) {
      setEndYearErrorMessage(endYearGreaterThanFEYear);
      setShowEndYearError(true);
    } else if (value && gmpStartYear && parseFloat(value) < gmpStartYear) {
      setEndYearErrorMessage(endYearLessThanStartYear);
      setShowEndYearError(true);
    } else {
      setEndYearErrorMessage("");
      setShowEndYearError(false);
    }
  };

  // On applying Simulate
  const onReset = () => {
    setSaveLoader(false);
    setGMPdataType("");
    setParameterName("");
    setForceCost("");
    setVariableType("");
    setSourceYear("");
    setSource("");
    setDependency("");
    setStartYearValue("");
    setSYValueError(false);
    setSYValueErrorMessage("");
    setUnit("");
    setGMPADUnit("");
    setStartYear("");
    setEndyear("");
    setCAGR("");
    setValueError(false);
    setCAGRError(false);
    setShowStartYearError(false);
    setShowEndYearError(false);
    setParamNameError(false);
    setHideFieldForDisRate(false);
    setHideFieldForIndependent(false);
    dispatch(setGMPHierarchy({ gmpHierarchyData: {} }));
    dispatch(setselectedUIAllFilters({ selectedUIAllFilters: {} }));
  };

  const onSave = async () => {
    dispatch(setWafErrorFlag(false));
    setSaveLoader(true);
    lastCheckedParamName.current = "";
    let uniqueParam = await handlecheckIfParamNameExist();
    if (uniqueParam === true) {
      let paramValidation = await checkDuplicateParamName();
      if (paramValidation.success === true) {
        let independentHierachrchy = IndependentHierachrchy;
        const payload = {
          engagementCode: engagement.engagementCode,
          engagementID: engagement.id,
          projectID: "00000000-0000-0000-0000-000000000000",
          projectName: "Test",
          moduleName: "Save-GMPRule",
          parameter_name: gmpParameterName,
          gmP_data_type: gmpdataType,
          force_as_cost: gmpForceCost ? gmpForceCost : "No",
          variable_type: gmpVariableType,
          source_year: Number(gmpSourceYear),
          source: gmpSource?.replace(/(http\S+)/g, "'$1'"),
          dependency: gmpDependency ? gmpDependency : "Emissions",
          start_Year_Value: Number(gmpStartYearValue),
          currency_unit: gmpCurrencyUnit,
          unit: gmpDependency === ACTIVITY_DATA_OPTION ? gmpADUnit : gmpUnit,
          start_year: Number(gmpStartYear),
          end_year: Number(gmpEndYear),
          cagr: Number(gmpCAGR),
          modifiedby: user.username,
          createdBy: user.username,
          hierarchialData:
            gmpVariableType === "Independent"
              ? independentHierachrchy
              : gmp.gmpHierarchyDataSet,
        };
        const data = await saveGMPData({ payload });
        if (data) {
          setToastMessage(true);
          updateGMPTable();
          onReset();
        }
      } else {
        setParamNameError(true);
        setParamNameErrorMessage(paramNameValidationMsg);
        onReset();
      }
    }

    setSaveLoader(false);
  };

  // Get data to refresh GMP table
  const updateGMPTable = async () => {
    const request = {
      engagement: engagement.engagementCode,
      viewType: "Default",
    };
    const data = await getGMPData({ request });
    dispatch(setGMPDetails({ gmpData: data }));
  };

  const handlecheckIfParamNameExist = async (event) => {
    if (gmpParameterName === "") return;
    if (!gmpParameterName || lastCheckedParamName.current === gmpParameterName) return;
    if (financialParameterNameRegExp.test(gmpParameterName) && gmpParameterName) {
      lastCheckedParamName.current = gmpParameterName;

      const data = await getUniqueParameterFlag({
        request: {
          parametername: encodeURIComponent(gmpParameterName),
          engagementcode: engagement.engagementCode
        },
      });

      if (data?.uniqueflag === false) {
        setParamNameError(true);
        setParamNameErrorMessage(paramNameUniqueMsg);
      } else {
        setParamNameError(false);
        setParamNameErrorMessage("");
      }

      return data?.uniqueflag ? true : false;
    }  
  };

  const hasHierarchySelection = !!gmp?.gmpHierarchyDataSet && Object.keys(gmp?.gmpHierarchyDataSet).length > 0;

  const isDependentVariable =
    gmpVariableType === addGMPVariableTypes.dependent;

  const selectedScopes = selectedUIAllFilters?.scope || [];

  const adUnitOptions = useMemo(() => {
    if (!selectedScopes.length) {
      return [];
    }

    const adUnitSet = new Set();

    (hierarchialData || []).forEach((data) => {
      // Check if the data row matches ALL selected hierarchy filters
      const matchesAllFilters = HIERARCHY_FILTER_KEYS.every((key) => {
        const selectedValues = selectedUIAllFilters?.[key];
        // If no filter is selected for this key, it matches by default
        if (!selectedValues || !Array.isArray(selectedValues) || selectedValues.length === 0) {
          return true;
        }
        // Handle blank values (empty strings represented as "(blank)" in UI)
        const dataValue = data[key];
        return selectedValues.includes(dataValue) || 
               (dataValue === "" && selectedValues.includes("(blank)"));
      });
      // If all filters match and AD_Unit exists, add it to the set
      if (matchesAllFilters && data?.AD_Unit) {
        adUnitSet.add(data.AD_Unit);
      }
    });

    return Array.from(adUnitSet);
  }, [hierarchialData, selectedUIAllFilters]);

  const hasADUnitOptions = adUnitOptions.length > 0;
  const isDiscountRateType = gmpdataType === DISCOUNT_RATE_OPTION;
  const shouldDisableDependentControls =
    isDiscountRateType || !isDependentVariable || !hasHierarchySelection;

  const dependencyOptions = useMemo(
    () =>
      (
        isDiscountRateType
          ? addGMPDependencyOptions
          : addGMPDependencyOptionsNew
      ).filter((option) => option !== ACTIVITY_DATA_OPTION || hasADUnitOptions),
    [isDiscountRateType, hasADUnitOptions, ACTIVITY_DATA_OPTION]
  );

  const shouldDisableADUnitSelector =
    !gmpdataType ||
    !gmpDependency ||
    !hasADUnitOptions ||
    (isDependentVariable && !hasHierarchySelection);

  const shouldDisableDataSelectionButton =
    !gmpdataType ||
    !gmpVariableType ||
    paramNameError;

  useEffect(() => {
    if (gmpDependency === ACTIVITY_DATA_OPTION && !hasADUnitOptions) {
      setDependency("");
      setGMPADUnit("");
    }
  }, [gmpDependency, hasADUnitOptions, ACTIVITY_DATA_OPTION]);

  return (
    <div className="add-gmp-params-section">
      <div className="add-gmp-params-title">
        <span>{setParameters}</span>
        <Tooltip
          trigger={<EmissionIcon />}
          variant="ghost"
          tooltipText={setparametersTooltip}
        ></Tooltip>
      </div>

      <div class="add-gmp-params-content">
        <div class="motif-row">
          <div class="motif-col-xs-2">
            <div className="add-gmp-params-content-row-dropdown">
              <span class="add-gmp-params-content-dropdowns-label">
                {addGMPParameterName}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={addGMPParamterTooltip}
                ></Tooltip>
              </span>
              <Input
                type="text"
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "gmpParameterName");
                }}
                errorMessage={paramNameErrorMessage}
                isError={paramNameError}
                value={gmpParameterName}
                onBlur={handlecheckIfParamNameExist}
                className="add-gmp-params-input"
              ></Input>
            </div>
          </div>
          <div class="motif-col-xs-1">
            <div className="add-gmp-params-content-row-dropdown">
              <span class="add-gmp-params-content-dropdowns-label">
                {addGMPparameterType} <span className="required-star">*</span>{" "}
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={addGMPDatatypeTooltip}
                ></Tooltip>
              </span>
              <Select
                options={addGMPDataTypeOptions}
                value={gmpdataType}
                onChange={(event) => {
                  handleOnChange(event, "gmpdataType");
                }}
              ></Select>
            </div>
          </div>
          <div class="motif-col-xs-1">
            <div className="add-gmp-params-content-row-dropdown">
              <span class="add-gmp-params-content-dropdowns-label">
                {addGMPVariableType} <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={vartypeTooltip}
                ></Tooltip>
              </span>
              <Select
                options={addGMPVariableTypeOptions}
                value={gmpVariableType}
                onChange={(event) => {
                  handleOnChange(event, "gmpVariableType");
                }}
                disabled={isDiscountRateType ? true : false}
              ></Select>
            </div>
          </div>
        </div>

        <div class="motif-row">
          <div class="motif-col-xs-2">
            <div className="add-gmp-params-content-row-dropdown">
              <span class="add-gmp-params-content-dropdowns-label">
                {addGMPSource}
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={sourceTooltip}
                ></Tooltip>
              </span>
              <Input
                type="text"
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "gmpSource");
                }}
                value={gmpSource}
                errorMessage={sourceErrorMessage}
                isError={sourceErrorMessage}
                maxLength={510}
                className="add-gmp-params-input"
              ></Input>
            </div>
          </div>
          <div class="motif-col-xs-1">
            <div className="add-gmp-params-content-row-dropdown">
              <span class="add-gmp-params-content-dropdowns-label">
                {addGMPSourceYear}
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={sourceYearTooltip}
                ></Tooltip>
              </span>
              <Input
                type="number"
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "gmpSourceYear");
                }}
                value={gmpSourceYear}
                maxLength={4}
              ></Input>
            </div>
          </div>
        </div>
        {hideFieldForIndependent === true ? (
          <></>
        ) : (
          <div class="motif-row">
            <div class="motif-col-xs-2">
              <Button
                variant="primary-alt"
                onClick={() => {
                  openHierarchyModal(true);
                }}
                disabled={shouldDisableDataSelectionButton}
                className="add-gmp-params-data-selection-btn"
              >
                <AreaSeacrhIcon />
                {DataSelection} <span className="required-star">*</span>
              </Button>
            </div>
          </div>
        )}
        <GMPHierarchy
          isFilterOpen={isHierarchyModalOpen}
          onClose={closeHierarchyModal}
        />

        <div class="motif-row">
          {hideFieldForIndependent === true || hideFieldForDisRate === true ? (
            <></>
          ) : (
            <div class="motif-col-xs-1">
              <div className="add-gmp-params-content-row-dropdown">
                <span class="add-gmp-params-content-dropdowns-label">
                  {addGMPDependency} <span className="required-star">*</span>
                  <Tooltip
                    trigger={<EmissionIcon />}
                    variant="ghost"
                    tooltipText={dependency}
                  ></Tooltip>
                </span>
                <Select
                  options={dependencyOptions}
                  value={gmpDependency}
                  onChange={(event) => {
                    handleOnChange(event, "gmpDependency");
                  }}
                  disabled={shouldDisableDependentControls ? true : false}
                ></Select>
              </div>
            </div>
          )}
          {hideFieldForIndependent === true || hideFieldForDisRate === true ? (
            <></>
          ) : (
            <div class="motif-col-xs-1">
              <div className="add-gmp-params-content-row-dropdown">
                <span class="add-gmp-params-content-dropdowns-label">
                  {addGMPForceCost} <span className="required-star">*</span>
                  <Tooltip
                    trigger={<EmissionIcon />}
                    variant="ghost"
                    tooltipText={forceAsCostTooltip}
                  ></Tooltip>
                </span>
                <Select
                  options={addGMPForceCostOptions}
                  value={gmpForceCost}
                  onChange={(event) => {
                    handleOnChange(event, "gmpForceCost");
                  }}
                  disabled={shouldDisableDependentControls ? true : false}
                ></Select>
              </div>
            </div>
          )}
        </div>
        <div class="motif-row">
          <div class="motif-col-xs-1">
            <div className="add-gmp-params-content-row-dropdown">
              <span class="add-gmp-params-content-dropdowns-label">
                {addGMPStartYear}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={addGMPstartYearTooltip}
                ></Tooltip>
              </span>
              <Input
                type="number"
                errorMessage={startYearErrorMessage}
                isError={showstartYearError}
                disableErrorPlaceholder={true}
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "gmpStartYear");
                }}
                value={gmpStartYear}
                maxLength={4}
              />
            </div>
          </div>
          <div class="motif-col-xs-1">
            <div className="add-gmp-params-content-row-dropdown">
              <span class="add-gmp-params-content-dropdowns-label">
                {addGMPEndyear}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={addGMPEndYearTooltip}
                ></Tooltip>
              </span>
              <Input
                type="number"
                errorMessage={endYearErrorMessage}
                isError={showendYearError}
                disableErrorPlaceholder={true}
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "gmpEndYear");
                }}
                value={gmpEndYear}
                maxLength={4}
              />
            </div>
          </div>
          <div class="motif-col-xs-1">
            <>
              <div className="add-gmp-params-content-row-dropdown">
                <span class="add-gmp-params-content-dropdowns-label">
                  {addGMPStartYearValue}
                  <span className="required-star">*</span>
                  <Tooltip
                    trigger={<EmissionIcon />}
                    variant="ghost"
                    tooltipText={addGMPStartValueTooltip}
                  ></Tooltip>
                </span>
                <Input
                  type="decimal"
                  errorMessage={valueSYErrorMessage}
                  isError={valueSYError}
                  onChange={(event) => {
                    handleOnChange(event?.target?.value, "gmpStartYearValue");
                  }}
                  value={gmpStartYearValue}
                ></Input>
              </div>
            </>
          </div>
          <div class="motif-col-xs-1">
            <div className="add-gmp-params-content-row-dropdown">
              <span class="add-gmp-params-content-dropdowns-label">
                {addGMPCAGR}
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={CAGRTooltip}
                ></Tooltip>
              </span>
              <Input
                type="decimal"
                disableErrorPlaceholder={true}
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "gmpCAGR");
                }}
                errorMessage={CAGRErrorMessage}
                isError={CAGRError}
                value={gmpCAGR}
              />
            </div>
          </div>
        </div>

        <div class="motif-row">
          {hideFieldForDisRate === true ? (
            <></>
          ) : (
            <div class="motif-col-xs-1">
              <div className="add-gmp-params-content-row-dropdown">
                <span class="add-gmp-params-content-dropdowns-label">
                  {addGMPCurrencyUnit}
                  <span className="required-star">*</span>
                  <Tooltip
                    trigger={<EmissionIcon />}
                    variant="ghost"
                    tooltipText={currencyUnitTooltip}
                  ></Tooltip>
                </span>
                <Input
                  type="text"
                  onChange={(event) => {
                    handleOnChange(event?.target?.value, "gmpCurrencyUnit");
                  }}
                  value={gmpCurrencyUnit}
                  disabled={true}
                  maxLength={30}
                ></Input>
              </div>
            </div>
          )}
          {hideFieldForIndependent === true || hideFieldForDisRate === true ? (
            <></>
          ) : (
            <div class="motif-col-xs-1">
              <div className="add-gmp-params-content-row-dropdown">
                <span class="add-gmp-params-content-dropdowns-label">
                  {addGMPUnit}
                  <span className="required-star">*</span>
                  <Tooltip
                    trigger={<EmissionIcon />}
                    variant="ghost"
                    tooltipText={addGMPUnitTooltip}
                  ></Tooltip>
                </span>
                {gmpDependency === ACTIVITY_DATA_OPTION ?
                  <MultiSelectCreatableOption
                    value={gmpADUnit}
                    onChange={(e) => { handleOnChange(e, "gmpADUnitField"); }}
                    id="base-year-scope-1-2"
                    avilableOptions={adUnitOptions}
                    label={selectGMPUnit}
                    overrideStrings={{
                      create: createNewGMPUnit,
                      search: SearchNewGMPUnit,
                    }}
                    hasSelectAll={false}
                    isCreatable={true}
                    disabled={shouldDisableADUnitSelector}
                  />
                  :
                  <Input
                    type="text"
                    onChange={(event) => {
                      handleOnChange(event?.target?.value, "gmpUnit");
                    }}
                    value={gmpUnit}
                    disabled={
                      !gmpdataType ||
                      !gmpDependency ||
                      gmpDependency === NOT_APPLICABLE_OPTION ||
                      gmpDependency === addGMPDependencyOptionsNew[1] ||
                      isDiscountRateType ||
                      (gmpDependency === addGMPDependencyOptionsNew[0] &&
                        gmpVariableType === addGMPVariableTypes.independent) ||
                      (isDependentVariable && !hasHierarchySelection)
                        ? true
                        : false
                    }
                    isError={dataUnitErrorMessage}
                    errorMessage={dataUnitErrorMessage}
                    className="add-gmp-params-input"
                  ></Input>}
                  {gmpDependency === ACTIVITY_DATA_OPTION && adUnitErrorMessage && 
                    <span className="error">
                      {adUnitErrorMessage}
                    </span>
                  }
              </div>
            </div>
          )}
          {wafErrorFlag && <div className="waf-error-message-gmp">
            {wafErrorMessageState}
          </div>} 
        </div>
        <div class="motif-row">
          <div class="motif-col-xs-1">
            <div className="add-gmp-params-buttons">
              <div className="add-gmp-params-buttons-div">
                <LoadingIndicatorEmbed show={simulateLoader}>
                  <Button
                    variant="primary-alt"
                    onClick={onReset}
                    disabled={isResetBtn}
                  >
                    <RefreshIcon />
                    Reset
                  </Button>
                </LoadingIndicatorEmbed>
              </div>
              <LoadingIndicatorEmbed show={saveLoader}>
                <Button
                  variant="primary"
                  className="add-gmp-params-button-save"
                  onClick={() => onSave()}
                  disabled={isSaveBtn || wafErrorFlag}
                >
                  <SaveIcon />
                  {SaveBtn}
                </Button>
              </LoadingIndicatorEmbed>
            </div>
          </div>
        </div>
      </div>
      <div className="add-gmp-params-footer">
        {toastMessage && (
          <ToastMessage
            onClose={() => setToastMessage(false)}
            message={FinancialParameterAddedSuccessfully}
            variant={"success"}
          ></ToastMessage>
        )}
      </div>
    </div>
  );
}
